module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAMAAAARtodwAAAAVFBMVEUAAABvb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb28G48jzAAAAHHRSTlMApwSghE6zqmspjH9iMBG5cUc3JB8arnqXXEE+0LpNygAAAKVJREFUGNN1kOsOgyAMRj+Vm1wVh059//dcATEz2U5CWw7tj4LfONMRzLV7b8WUgKSE6qvZw1KLl7BFLYLEpcKY07RRiFrPrcZA3q077zg1Ddl0NMssML+Bvho6RgGcDO6eUSorj9YzOJAy7MypGKtxw1SOaT2biOurZC59Fb7j117M1H02XTOwyPI2yxGZWqc202AMMBpfeHFE4Z+/GELEEzXhLx/NLQWelb9SDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location.png
// module id = xnra
// module chunks = 0